import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Modal from "./Modal.js";
import ModalBody from "./ModalBody.js";
import "./InfoModal.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * A modal that displays a message with an icon. Can be used for informational messages, warnings, or errors.
 * Does not have any buttons and cannot be dismissed.
 */
function InfoModal(_ref) {
  var className = _ref.className,
    icon = _ref.icon,
    _ref$isOpen = _ref.isOpen,
    isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
    subtitle = _ref.subtitle,
    title = _ref.title;
  return /*#__PURE__*/_jsx(Modal, {
    isOpen: isOpen,
    className: className,
    children: /*#__PURE__*/_jsx(ModalBody, {
      children: /*#__PURE__*/_jsxs("div", {
        className: "info-modal",
        children: [icon != null && /*#__PURE__*/_jsx("div", {
          className: "message-icon",
          children: /*#__PURE__*/_jsx(FontAwesomeIcon, {
            icon: icon
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "message-header",
          children: title
        }), subtitle != null && /*#__PURE__*/_jsx("div", {
          className: "message-content",
          children: subtitle
        })]
      })
    })
  });
}
export default InfoModal;
//# sourceMappingURL=InfoModal.js.map